import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class ResumeKedisiplinanFuTeleMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Resume Kedisiplinan FU"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.resumeByTerlambatSales?.map(lead => {
                            return (
                            <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <strong>{lead.assignToUserName}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"left"}>
                                        Jumlah FU<br />
                                        <strong>{lead.jumlahFu}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        On Time<br />
                                        <strong>{lead.jumlahOnTime}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        Terlambat<br />
                                        <strong>{lead.jumlahTerlambat}</strong>
                                    </Grid>
                                </Grid>
                                <Divider sx={{mt: "8px"}} />
                            </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default ResumeKedisiplinanFuTeleMobile;